import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, hashHistory } from 'react-router';
import { Provider } from 'react-redux';
import { App } from './components/App';
import { AudioEditorApp } from './components/AudioEditorApp';
import { AudioPlayerApp } from './components/AudioPlayerApp';
import { AppPrint } from './components/AppPrint';
import { AppPrintEditor } from './components/AppPrintEditor';
import storeManager from './store/StoreManager';
import dataLoader from './DataLoader';
import properties from './constants/Properties';
import platformDetection from './components/utils/PlatformDetection';
import appParameters from './components/utils/AppParameters';
import modeType from './constants/ModeConstants';
import localesManager from './locales/LocalesManager';

require('./styles/base.scss');
require('../node_modules/font-awesome/scss/font-awesome.scss');
require('./styles/fonts/cartoonistFonts.scss');
require('./styles/fonts/cartoonistIcons.css');

window.Promise = require('bluebird');

Promise.config({
    warnings: false
});

const store = storeManager.configureAndSetStore({});

properties.init();

if (platformDetection.isIE() == true)
    localesManager.init();
else
    dataLoader.loadData();

var routes;

switch(appParameters.context) {
    case modeType.PRINT: {
        routes = (<Route path="/" component={AppPrint}/>);
        break;
    }
    case modeType.PRINT_EDITOR: {
        routes = (<Route path="/" component={AppPrintEditor}/>);
        break;
    }
    case modeType.AUDIO_TOOL: {
        routes = (<Route path="/" component={AudioEditorApp}/>);
        break;
    }

    case modeType.EXPORT_PLAYER:
    case modeType.EXPORT_AUDIO_PLAYER:
    case modeType.AUDIO_TOOL_PLAYER: {
        routes = (<Route path="/" component={AudioPlayerApp}/>);
        break;
    }

    default: {
        routes = (<Route path="/" component={App}/>);
    }
}

ReactDOM.render(
    <Provider store={store}>
        <Router history={hashHistory}>
            {routes}
        </Router>
    </Provider>,
    document.getElementById('wrapper')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/